<form>
  <div class="wrapper">
    <div class="container px-0">
      <h5 class="main-title">{{ 'madisoninsurance.mainTitle' | translate }}</h5>
      <div class="main-info">
        <strong>{{ 'madisoninsurance.mainInfo' | translate }}</strong>
      </div>
      <div>
        <ul class="flex-nowrap justify-content-center nav nav-tabs text-center" id="myTab" role="tablist">
          <li class="nav-item w-100">
            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab"
               aria-controls="home" aria-selected="true" data-target="#primary">{{ 'madisoninsurance.tabPrimary' | translate }}</a>
          </li>
          <li class="nav-item w-100">
            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab"
               aria-controls="profile" aria-selected="false" data-target="#secondary">{{ 'madisoninsurance.tabSecondary' | translate }}</a>
          </li>
          <li class="nav-item w-100">
            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab"
               aria-controls="contact" aria-selected="false" data-target="#Others">{{ 'madisoninsurance.tabOthers' | translate }}</a>
          </li>
        </ul>
        <div class="tab-content pt-4" id="myTabContent">
          <div class="tab-pane fade show active" id="primary" role="tabpanel" aria-labelledby="home-tab">
            <p class="text-center text-primary">
              {{ 'madisoninsurance.imageCaptureInstruction' | translate }}
            </p>
            <div class="bg-light p-3 rounded">
              <div class="row text-center">
                <div class="col-md-6 mb-3 mb-md-0">
                  <div class="mb-2"><img class="img-fluid cap-img" [src]="defaultImagefront"></div>
                  <button type="button" class="btn btn-primary upload-btn px-0"
                          (click)="CheckType('primary')">
                    <input type="file" id="fileFront" class="d-none"
                           (change)="onChangeFileFront($event)"
                           accept="image/png, image/gif, image/jpeg,image/jpg">
                    <label for="fileFront">
                      <span class="file-button">
                        {{ 'madisoninsurance.buttonAddCardFront' | translate }}
                        <i class="fas fa-camera text-white ml-2"></i>
                      </span>
                    </label>
                  </button>
                </div>
                <div class="col-md-6">
                  <div class="mb-2"> <img class="img-fluid cap-img" [src]="defaultImageback"></div>
                  <button type="button" class="btn btn-primary upload-btn px-0">
                    <input type="file" id="fileBack" class="d-none"
                           (change)="onChangeFileBack($event)"
                           accept="image/png, image/gif, image/jpeg,image/jpg">
                    <label for="fileBack">
                      <span class="file-button">
                        {{ 'madisoninsurance.buttonAddCardBack' | translate }}
                        <i class="fas fa-camera text-white ml-2"></i>
                      </span>
                    </label>
                  </button>
                </div>
              </div>
            </div>

          </div>
          <div class="tab-pane fade" id="secondary" role="tabpanel" aria-labelledby="profile-tab">

            <p class="text-center text-primary">
              {{ 'madisoninsurance.imageCaptureInstruction' | translate }}
            </p>
            <div class="bg-light p-3 rounded">
              <div class="row text-center">
                <div class="col-md-6 mb-3 mb-md-0">
                  <div class="mb-2"><img class="img-fluid cap-img" [src]="defaultImagefront"></div>
                  <input #file hidden type="file" (change)="onChangeFileFront($event)"
                         onclick="this.value=null">
                  <button type="button" class="btn btn-primary upload-btn px-0" id="fileFront_S"
                          (click)="file.click();CheckType('secondary')">
                    <label>
                      <span class="file-button">
                        {{ 'madisoninsurance.buttonAddCardFront' | translate }}
                        <i class="fas fa-camera text-white ml-2"></i>
                      </span>
                    </label>
                  </button>
                </div>
                <div class="col-md-6">
                  <div class="mb-2"> <img class="img-fluid cap-img" [src]="defaultImageback"></div>
                  <button type="button" class="btn btn-primary upload-btn px-0">
                    <input type="file" id="fileBack_S" class="d-none"
                           (change)="onChangeFileBack($event)"
                           accept="image/png, image/gif, image/jpeg,image/jpg">
                    <label for="fileBack">
                      <span class="file-button">
                        {{ 'madisoninsurance.buttonAddCardBack' | translate }}
                        <i class="fas fa-camera text-white ml-2"></i>
                      </span>
                    </label>
                  </button>
                </div>
              </div>
            </div>

          </div>
          <div class="tab-pane fade" id="Others" role="tabpanel" aria-labelledby="contact-tab">
            <p class="text-center text-primary">
              {{ 'madisoninsurance.imageCaptureInstruction' | translate }}
            </p>
            <div class="bg-light p-3 rounded">
              <div class="row text-center">
                <div class="col-md-6 mb-3 mb-md-0">
                  <div class="mb-2"><img class="img-fluid cap-img" [src]="defaultImagefront"></div>
                  <input #file hidden type="file" (change)="onChangeFileFront($event)"
                         onclick="this.value=null">
                  <button type="button" class="btn btn-primary upload-btn px-0" id="fileFront_O"
                          (click)="file.click();CheckType('other')">
                    <label>
                      <span class="file-button">
                        {{ 'madisoninsurance.buttonAddCardFront' | translate }}
                        <i class="fas fa-camera text-white ml-2"></i>
                      </span>
                    </label>
                  </button>

                </div>
                <div class="col-md-6">
                  <div class="mb-2"> <img class="img-fluid cap-img" [src]="defaultImageback"></div>
                  <button type="button" class="btn btn-primary upload-btn px-0">
                    <input type="file" id="fileBack_O" class="d-none"
                           (change)="onChangeFileBack($event)"
                           accept="image/png, image/gif, image/jpeg,image/jpg">
                    <label for="fileBack">
                      <span class="file-button">
                        {{ 'madisoninsurance.buttonAddCardBack' | translate }}
                        <i class="fas fa-camera text-white ml-2"></i>
                      </span>
                    </label>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>



      </div>

    </div>
  </div>
  <footer class="p-3">
    <div class="container p-0">
      <div class="text-right">
        <button type="button" class="btn btn-primary" data-toggle="modal"
                (click)="callOCRinsuranceService()">
          {{ 'button.next' | translate }}
        </button>
      </div>
    </div>
  </footer>
</form>

<div class="modal modal-md collapse" id="ConsentForm1" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-scrollable modal-lg">
    <div class="modal-content">
      <div class="bg-white justify-content-center modal-header">

        <img src="../../../assets/images/Madisonsportslogo.png" />

      </div>
      <div class="modal-body" style="max-height: 100vh;" #scrollCaptureInsurance>

        <div [innerHTML]="'madisoninsurance.patientRightsAndResponsibilities' | translate"></div>




        <!--<p>
            <b>Notice of Patient Rights:</b><br><br>
            The New Jersey Department of Health and Senior Services have established the following patient
            rights for patients receiving health care services in an outpatient setting: <br>
            Each patient receiving service in an ambulatory care facility shall have the following rights:
        </p>
        <ul>
            <li>
                To be informed of theirs rights, as evidenced by the patient's written acknowledgement, or by
                documentation by staff in the medical record, that the patient was offered a written copy of
                these rights and given a written or verbal explanation of these rights, in terms the patient
                could understand;
                <ul>
                    <li>The facility will notify patients of any rules and regulations it has adopted governing
                        patient conduct in the facility</li>
                </ul>
            </li>
            <li>To be informed of services available in the facility, of the names and professional status of
                the personnel providing and/or responsible for the patient's care, and of fees and related
                charges, including the payment, fee, deposit, and refund policy of the facility and any charges
                for services not covered by sources of third-party payment or not covered by the facility's
                basic rate;
                <ul>
                    <li>All staff will wear identification badges which include their name and credentials.</li>
                </ul>
            </li>
            <li>To be informed if the facility has authorized other health care and educational institutions to
                participate in the patient's treatment. The patient also shall have a right to know the identity
                and function of these institutions, and to refuse to allow their participation in the patient's
                treatment;</li>
            <li>To receive from the patient's physician(s) or clinical practitioner(s), in terms that the
                patient understands, an explanation of his or her complete medical/health condition or
                diagnosis, recommended treatment, treatment options, including the option of no treatment,
                risk(s) of treatment, and expected result(s). If this information would be detrimental to the
                patient's health, or if the patient is not capable of understanding the information, the
                explanation shall be provided to the patient's next of kin or guardian. This release of
                information to the next of kin or guardian, along with the reason for not informing the patient
                directly, shall be documented in the patient's medical record;</li>
            <li>To participate in the planning of the patient's care and treatment, and to refuse medication and
                treatment. Such refusal shall be documented in the patient's medical record;</li>
            <li>To be included in experimental research only when the patient gives informed, written consent to
                such participation, or when a guardian gives such consent for an incompetent patient in
                accordance with law, rule and regulation. The patient may refuse to participate in experimental
                research, including the investigation of new drugs and medical devices;</li>
            <li>To voice grievances or recommend changes in policies and services to facility personnel, the
                governing authority, and/or outside representatives of the patient's choice either individually
                or as a group, and free from restraint, interference, coercion, discrimination, or reprisal;
            </li>
            <li>To be free from mental and physical abuse, free from exploitation, and free from use of
                restraints unless they are authorized by a physician for a limited period of time to protect the
                patient or others from injury. Drugs and other medications shall not be used for discipline of
                patients or for convenience of facility personnel;</li>
            <li>To confidential treatment of information about the patient;
                <ul>
                    <li>Information in the patient's medical record shall not be released to anyone outside the
                        facility without the patient's approval, unless another health care facility to which
                        the patient was transferred requires the information, or unless the release of the
                        information is required and permitted by law, a third-party payment contract, or a peer
                        review, or unless the information is needed by the Department for statutorily authorized
                        purposes.</li>
                    <li>The facility may release data about the patient for studies containing aggregated
                        statistics when the patient's identity is masked;</li>
                </ul>
            </li>
            <li>To be treated with courtesy, consideration, respect, and recognition of the patient's dignity,
                individuality, and right to privacy, including, but not limited to, auditory and visual privacy.
                The patient's privacy shall also be respected when facility personnel are discussing the
                patient;</li>
            <li>To not be required to perform work for the facility unless the work is part of the patient's
                treatment and is performed voluntarily by the patient. Such work shall be in accordance with
                local, State, and Federal laws and rules;</li>
            <li>To exercise civil and religious liberties, including the right to independent personal
                decisions. No religious beliefs or practices, or any attendance at religious services, shall be
                imposed upon any patient;</li>
            <li>To not be discriminated against because of age, race, religion, sex, nationality, or ability to
                pay, or deprived of any constitutional, civil, and/or legal rights solely because of receiving
                services from the facility;</li>
            <li>To expect and receive appropriate assessment, management and treatment of pain as an integral
                component of that person’s care in accordance with N.J.A.C. 8:43E-6.</li>
            <li>If a patient is adjudged incompetent under applicable State laws by a court of proper
                jurisdiction, the rights of the patient are exercised by the person appointed under State law to
                act on the patient’s behalf.</li>
            <li>If a State court has not adjudged a patient incompetent, any legal representative designated by
                the patient in accordance with State law may exercise the patient’s rights to the extent allowed
                by State law.</li>
        </ul>
        <p><b>Patient Responsibilities:</b></p>
        <ul>
            <li>To provide complete and accurate information to the best of their ability about their health,
                any medications, including over-the-counter products and dietary supplements and any allergies
                or sensitivities;</li>
            <li>To follow the treatment plan prescribed by their provider;</li>
            <li>To inform their provider about any living will, medical power of attorney, or other advance
                healthcare directive in effect;</li>
            <li>To accept personal financial responsibility for any charges not covered by their insurance;</li>
            <li>To behave respectfully toward all the health care professional and staff, as well as other
                patients.</li>
        </ul>
        <p><b>Complaints:</b></p>
        <ul>
            <li>
                Complaints may be made to:
                <ul>
                    <li>
                        Governing Authority
                        <ul>
                            <li><b>Dr Carmen Romano</b></li>
                            <li><b>345 Main Street, Madison, NJ 07940</b></li>
                            <li><b>973-377-6700</b></li>
                        </ul>
                    </li>
                    <li>Office of Acute Care Assessment and Survey <br>

                        New Jersey Department of Health <br>
                        Division of Health Facility Survey and Field Operations<br>
                        PO Box 367<br>
                        Trenton, NJ 08625-0367 <br>
                        Complaint Hotline: 1-800-792-9770 <br>
                        Online: https://web.doh.state.nj.us/fc/search.aspx
                    </li>
                    <li>Office of Ombudsman for the Institutionalized Elderly <br>
                        NJ Long-Term Care Ombudsman<br>
                        P.O. Box 852<br>
                        Trenton, NJ 08625-085 <br>
                        Complaint Hotline: (877) 582-6995 <br>
                        Online: ombudsman@ltco.nj.gov</li>
                </ul>
            </li>
        </ul>
        <p><b>Medicare/Medicaid Information:</b></p>
        <p>
            NJ Medicare Information & Referral Service: 1-800-792-8820 <br>
            For questions about New Jersey Medicaid, call 1-800-356-1561 <br>
            For questions about NJ FamilyCare call 1-800-701-0710
        </p>
        <p><b>The facility’s normal hours of operation are:</b></p>
        <p>Monday-8:30-5:30</p>
        <p>Tuesday-7:30-3:30</p>
        <p>Wednesday-8:30-5:30</p>
        <p>Thursday-10:30-6:00</p>
        <p>Friday-7:30-1:00</p>
        <p>Saturday-9:00-1:00</p>-->
      </div>
      <div class="modal-footer">

        <button type="button" class="btn btn-primary" (click)="SignConsent()">Sign</button>
      </div>
    </div>
  </div>
</div>


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="isNotValid_format">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h6 class="font-weight-bolder mb-3 text-danger">
          <strong>
            {{ 'madisoninsurance.invalidFormat' | translate }}

          </strong>
        </h6>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                id="close_invalidemodel">
          {{ 'button.ok' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
